export class S1ProcessContainerID {
    id:number;
}